import React from 'react';

export function Input({ 
  label, 
  error, 
  helperText,
  className = '',
  ...props 
}) {
  const inputId = props.id || props.name;

  return (
    <div>
      {label && (
        <label htmlFor={inputId} className="block text-sm font-medium text-muted-foreground mb-2">
          {label}
        </label>
      )}
      <input
        id={inputId}
        {...props}
        className={`w-full px-3.5 py-2.5 rounded-lg transition-all duration-200 focus:outline-none border ${
          error 
            ? 'border-danger focus:border-danger focus:ring-2 focus:ring-danger/20' 
            : 'border-border/60 focus:border-accent focus:ring-2 focus:ring-accent/20'
        } bg-background-soft text-foreground placeholder:text-muted-foreground/60 ${className}`}
      />
      {error && <p className="text-danger text-xs mt-2">{error}</p>}
      {helperText && !error && (
        <p className="text-muted-foreground/80 text-xs mt-2">{helperText}</p>
      )}
    </div>
  );
}

export function Select({ 
  label, 
  error, 
  helperText,
  children,
  className = '',
  ...props 
}) {
  const selectId = props.id || props.name;

  return (
    <div>
      {label && (
        <label htmlFor={selectId} className="block text-sm font-medium text-muted-foreground mb-2">
          {label}
        </label>
      )}
      <select
        id={selectId}
        {...props}
        className={`w-full px-3.5 py-2.5 rounded-lg transition-all duration-200 focus:outline-none border ${
          error 
            ? 'border-danger focus:border-danger focus:ring-2 focus:ring-danger/20' 
            : 'border-border/60 focus:border-accent focus:ring-2 focus:ring-accent/20'
        } bg-background-soft text-foreground cursor-pointer ${className}`}
      >
        {children}
      </select>
      {error && <p className="text-danger text-xs mt-2">{error}</p>}
      {helperText && !error && (
        <p className="text-muted-foreground/80 text-xs mt-2">{helperText}</p>
      )}
    </div>
  );
}

export function Textarea({ 
  label, 
  error, 
  helperText,
  className = '',
  ...props 
}) {
  const textareaId = props.id || props.name;

  return (
    <div>
      {label && (
        <label htmlFor={textareaId} className="block text-sm font-medium text-muted-foreground mb-2">
          {label}
        </label>
      )}
      <textarea
        id={textareaId}
        {...props}
        className={`w-full px-3.5 py-2.5 rounded-lg transition-all duration-200 focus:outline-none border ${
          error 
            ? 'border-danger focus:border-danger focus:ring-2 focus:ring-danger/20' 
            : 'border-border/60 focus:border-accent focus:ring-2 focus:ring-accent/20'
        } bg-background-soft text-foreground placeholder:text-muted-foreground/60 resize-vertical ${className}`}
      />
      {error && <p className="text-danger text-xs mt-2">{error}</p>}
      {helperText && !error && (
        <p className="text-muted-foreground/80 text-xs mt-2">{helperText}</p>
      )}
    </div>
  );
}
